/* eslint-disable quotes */
// Tcheco
export const tcheco = {
  start: "Spustit",
  configurations: "Nastavení",
  ramdom: "Režim náhodného přehrávání",
  vibration: "Vibrace :",
  startgame: "Zahájení hry",
  save: "Zachránit",
  delete: "Odstranit",
  update: "Aktualizace",
  lets: "Pojďme hrát",
  permanentbuy: "Trvalé nákupy",
  signature: "Měsíční předplatné",
  signatureano: "Roční předplatné",
  small: "Zde můžete použít své skutečné jméno... nebo přezdívku :)",
  text1: "Získejte prémiový přístup a zaručte si všechny aktualizace",
  text2: "Předplatným získáte přístup k verzi Premium, kdykoli budete chtít.",
  gender: "Žánr",
  male: "Muž  ",
  female: "Ženy",
  ambos: "Oba",
  fechar: "Zavřete",
  sexualorientation: "Sexuální orientace",
  heterosexual: "Heterosexuální",
  homosexual: "Homosexuální",
  bisexual: "Bisexuální",
  chooseavatar: "Vyberte si svého avatara",
  Participants: "Účastníci",
  participant: "Registrace účastníka",
  name: "Název",
  choosecategory: "Vyberte kategorie",
  categories: "Kategorie",
  light: "Světlo",
  preliminary: "Předběžný",
  oral: "Ústní",
  anal: "Anál",
  hot: "Horké",
  extreme: "Extrémní",
  vd: "Pravda  ?",
  dare: "Výzvy ?",
  truth: "Pravda",
  time: "Čas",
  createMyChallenges: "Vytvořit mé výzvy ✏️",
  chosen: "Vybrané",
  text3: "Nechte v sobě probudit lásku!",
  text4: "Připravte se na intenzivní život",
  close: "Zavři",
  sele: "Vybrat možnost",
  dev: "Vyvinul Dev12BR",
  game: "Hra",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "DALŠÍ",
  config1: "Proč bych si měl koupit verzi Premium ?",
  config2: "Exkluzivní kategorie a více než 800 nových výzev",
  config3: "Bez reklam",
  config4: "Vyberte avatary pro zvýšení",
  config5: "Vytvořte si vlastní výzvy ",
  config6: "Podporujete vývoj her",
  config7: "Proč hra stojí peníze?",
  config8:
    "K vývoji hry potřebujete čas! :) Tímto způsobem hru podpoříte a pomůžete nám, abychom ji mohli neustále vylepšovat a aktualizovat.",
  config9: "Vytvářejte a upravujte vlastní výzvy",
  age: `Tato hra je určena pouze pro dospělé, takže vám musí být alespoň 18 let. Výběrem možnosti "Ano" vyjadřujete souhlas s podmínkami používání a zásadami ochrany osobních údajů. 

  Tato hra je vhodná pro páry, takže ji musíte hrát alespoň s jedním partnerem. 
  
  Nejedná se o seznamovací aplikaci, ale o způsob, jak si hrát s partnerem.
    `,
  config10: "Exkluzivní kategorie",
  config11: "+ 800 nových výzev",
  assessment:
    "Ohodnoťte prosím aplikaci přidáním komentáře. Vaše zpětná vazba je pro nás velmi důležitá, abychom mohli hru udržet co nejlepší.",
  agree: "Ano, je mi více než 18 let",
  noAgree: "Zavřít aplikaci",
  apoio1: "Podpořte vývoj předplatným verze Premium :)",
  apoio2: "Nezapomeňte ohodnotit aplikaci v obchodě S2",
  apoio3: "Získejte přístup ke všem exkluzivním funkcím verze Premium",
  apoio4: "Zbavte se tohoto banneru - kupte si verzi Premium",
  version: "Premium verze",
  version1: "Premium verze",
  alert1: "Registrace uživatelů pro hraní",
  alert2: "Zaregistrujte alespoň jednoho dalšího uživatele, který bude hrát",
  alert3: "Vyberte alespoň jednu kategorii",
  alert4: `🔥 Jsou účastníci bez partnerů. Zúčastněte se alespoň dva zástupci každého pohlaví 🔞.  
        
Příklad: dva heterosexuálové nebo dva homosexuálové.`,
  tituloAlert1: "⚠️ Hra za chvíli začne 😜",
  tituloAlert2:
    "⚠️ Škoda 😬, Jste bez internetu 📶. Zapněte internet na svém zařízení a kupte si předplatné nebo konečný tarif. A buďte šťastní😘.",
  parser: "Žádný partner",
  premiumImages:
    "Staňte se prémiovým uživatelem a získejte přístup k dalším avatarům",
  duvidas: "Otázky nebo návrhy - Pikantní výzvy",
  description: "Dobrý den, můj dotaz nebo návrh je :",
  texto99:
    "Pokud máte nějaké problémy, dotazy nebo návrhy, pošlete nám e-mail kliknutím na toto tlačítko níže. Těšíme se na rozhovor s vámi!",
  send: "Odeslat",
  contact: "Kontakt",
  botaoApple: "Obnovit nákupy",
  alertCompra: "Váš nákup se obnovuje",
  NotPurchase: "Nemáte žádné nákupy",
  notPurchase2:
    "Tento odkaz je určen pouze pro uživatele, kteří si zakoupili předchozí produkty a chtějí je obnovit v novém zařízení.",
  termOfPotitic: "Podmínky používání a zásady ochrany osobních údajů",
  alertDeuErrado: "Něco se pokazilo :(",
  alertDeuErrado2: "Vyplňte všechny informace",
  alertNome: "Vyplňte pole: Název",
  options: "Možnosti",
  optionsTitle: "Možnosti",
  gradualGame: "Postupná přehrávka",
  textoCaixa:
    "Po aktivaci této volby budou výzvy postupné, tj. od nejlehčí po nejextrémnější podle vašeho výběru.",
  comoJogar: "Jak hrát? 🤔",
  avalie: "Hodnotit",
  novaCategoria: "Moje kategorie",
  alterLanguage: "Změnit jazyk ?",
  textLanguage: "Při změně jazyka se aplikace restartuje",
  textLanguage1: "Změnit jazyk",
  cancel: "Zrušit",
  languages: "Jazyky",
  email: "@email ✉️",
  deletCat: "Smazat kategorii",
  textDeletCat:
    "Odstraněním této kategorie budou odstraněny výzvy, které se v ní nacházejí. Po této akci ji již nelze vrátit zpět.",
  deletDes: "Smazat výzvu",
  textDeletDes: "Po odstranění výzvy již nelze tuto akci vrátit zpět.",
  desafio: "Registrovat novou výzvu",
  desafiotexto: "Výzvy",
  textoeditDesafio: "Kdo to dokáže ?",
  textEmquem: "Na koho ?",
  nome: "Název",
  inicio: "Spustit hru",
  inicio2:
    "Stisknutím tohoto tlačítka se dostanete na obrazovku registrace hráče 👥.",
  inicio3: "Hra za chvíli začne 🎲",
  inicio4: "Další",
  inicio5: "Nastavení",
  inicio6: `Nastavení jako: 
  
- Progresivní výzvy
- Změna jazyka výzev 
- Vytváření výzev 
- Podpora 
- a tak dále`,
  inicio7: "Konec",
  inicio8: `Buďte Premium a získejte přístup k:

- Více než 450 nových výzev 😎
  
- Exkluzivní znaky 🦸♀️ 🧑🚒
  
- Vytvořte si vlastní výzvy 📝
  
- Udržujte hru aktualizovanou ✅
  
- A mnoho dalšího 😍`,
  inicio9: "Nápověda",
  inicio10: "Vítejte ve hře Spicy Challenges 🌶",
  inicio11:
    "Podívejte se, jak snadné je hrát a procházet nabídkami za méně než 30 sekund 😎",
  inicio12: "Viz výukový program 👍🏼",
  inicio13: "Nechci 👎🏼",
  inicio14: `Pro zahájení hry musíte přidat alespoň (2) dva hráče 😀
              
Stisknutím výše uvedeného tlačítka 👆
    
Při každém přidání nového uživatele stiskněte stejné tlačítko 😘`,
  cadastrarCategory: "Registrace Kategorie",
  inicio15: "Vytvoření nové kategorie",
  inicio16:
    "Krok 1 : Stiskněte tlačítko se znaménkem +, které se nachází v dolní části této obrazovky. Po stisknutí se zobrazí okno pro zadání nové kategorie",
  inicio17: "Krok 2: Zadejte novou kategorii a klikněte na tlačítko uložit",
  inicio18:
    "Krok 3: Chcete-li upravit tuto kategorii nebo PŘIDAT výzvy v rámci kategorie, klikněte na ni",
  inicio19:
    "Krok 4: Na další obrazovce stiskněte tlačítko označené šipkou ⬆️ a otevře se okno pro úpravu nové kategorie.",
  inicio20:
    "Krok 5: Na další obrazovce stisknutím tlačítka označeného šipkou ⬆️ odstraníte kategorii.",
  inicio21:
    "Krok 1: Stisknutím níže uvedeného tlačítka přidat novou výzvu do této kategorie",
  inicio22: "Vytvoření nové výzvy",
  inicio23:
    "Krok 2: Stiskněte každou zakroužkovanou položku, abyste se podrobně seznámili s jednotlivými poli rejstříku",
  inicio24: "Text úkolu",
  inicio25: `Napište výzvu podle svých představ a pro zobrazení jména hráče ve výzvě stačí stisknout červené tlačítko níže. 
    
Přidá následující znaky {nome}. 
  
** NEMĚNĚTE TYTO ZNAKY ** Protože aby se název zobrazil odpovídajícím způsobem, musí být takový, jak je popsáno níže ⬇️⬇️⬇️⬇️⬇️.
  
Výzva: Polib krk {nome}`,
  inicio26: "Kdo může dělat a kdo může přijímat",
  inicio27: `Zvolte "Both", pokud výzvu mohou provést a přijmout účastníci "obou" pohlaví.
  
Pokud je výzva zaměřena na jedno pohlaví, jednoduše vyberte požadované pohlaví.
`,
  inicio28: "Přidání času k výzvě",
  inicio29:
    'Pokud je v úkolu uveden čas, stačí přetáhnout "rozsah" níže a hodnota se zobrazí nahoře. Po uplynutí času výzvy se ozve zvuk, který vás informuje o jejím konci.',
  aviso12: `Tady pouze vytvoříte kategorii!
    
Pro přidání výzev stačí stisknout tlačítko pro právě vytvořenou kategorii ⬆️⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Vrať se",
  semDe: "Hráč bez registrovaných výzev",
  semDe2: `Zaregistrujte alespoň jednu výzvu pro tohoto hráče 😬.
  
Budete přesměrováni na přihlašovací obrazovku.`,
  term: "Soukromí",
  Potitic: "Podmínky používání",
  adquirited: "Získaný",
  camera: "Fotoaparát",
  galery: "Galerie",
  avatar: "Avatar",
  image: "Obrázek",
  seletion: " Vybrané",
  editCategory: "Upravit kategorii",
  frase1: "Líbí se vám aplikace Pikantní výzvy?",
  frase2: "Co takhle vyzkoušet prémiové výzvy?",
  //err texto
  errTitulo: "Všimli jste si něčeho špatného?",
  errTexto:
    "Pokud jste našli chybu v překladu, opravte ji v níže uvedeném poli:",
  errCorrect: "Správná věta by měla znít:",
  errSend: "Odeslat návrh",

  share: "Sdílet",
  fraseShare: `Co je to za špičkovou aplikaci! Jen se o to podělím, protože vím, že se vám to bude také líbit!🫣
  Stáhněte si to a pak mi řekněte, jestli to není moc dobrý lol...😉
  
  
  Odkaz ke stažení: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇨🇿",

  morePlayer: "Hra pro více hráčů?",
  players: "hráčů",
  carregar: "Nahrát obrázek",
  takePhoto: "Pořízení snímku nebo výběr obrázku",
  useAvatar: "Nebo použijte avatary",

  hetero: "Heterosexuální pár",
  gay: "Homosexuální pár",
  lesbico: "Lesbický pár",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Přidání hráčů 🙌",
  descricaoErr: "Zadejte jména účastníků ✍️",
  why: "Řekněte nám proč...",
  later: "Vyhodnoťte později",
  txtCard1: "Jste na řadě 🔥",
  txtCard2: "Udělej to 😘",
  txtCard3: "No tak! 😜",
  txtCard4: "Další úkol 😈",
  txtCard5: "Ještě jedna! 👄",

  tituloBloco1Novo: "Prozkoumejte sexuální intimitu se svým partnerem",
  subtitulo1Novo: "Více než 1 milion šťastných párů",
  texto1Novo:
    "Prozkoumejte intimitu se svým partnerem a získejte přístup k nejlepším párovým hrám! Odemkněte všechny kategorie her a zlepšete své spojení s láskou!",

  tituloBloco2Novo: "Nové zkušenosti a lepší vztahy",
  texto2Novo1: "Užijte si výzvy +1500",
  texto2Novo2: "Vytvořte si vlastní výzvy",
  texto2Novo3: "Exkluzivní kategorie",
  texto2Novo4: "Žádné reklamy",
  texto2Novo5: "Exkluzivní avatary",
  texto2Novo6: "Nové výzvy každý den",
  texto2Novo7: "Pravidelně aktualizované hry",
  tituloBloco3Novo: "Nejvyšší hodnocení v kategorii",
  tituloBloco4Novo: "Výhody pro váš vztah: ",
  texto4Novo1: "Intimita",
  texto4Novo2: "touha",
  texto4Novo3: "lehkost",
  texto4Novo4: "přitažlivost",
  texto4Novo5: "spojení",
  texto4Novo6: "potěšení",

  tituloBloco5Novo: "Co říkají páry",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Myslím, že tohle je nejlepší aplikace, jakou jsem zatím na mobilu našel. Je erotická a zajímavá a žádná jiná aplikace, kterou jsem viděl, se s ní nemůže srovnávat. Najděte si práci a kupte si ji. Nestěžujte si, že nemáte peníze. Přicházíte o opravdu skvělé věci a za pouhých 10 dolarů můžete mít celou aplikaci. Nabízí lepší zážitky než hry, které najdete v místních obchodech pro dospělé.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Tato aplikace je úžasná! Váhal jsem, jestli si ji mám stáhnout, ale byl to rozhodně nejlepší pocit, jaký jsme v poslední době zažili. Je skvělé vědět, že spolu stále můžeme dělat tolik věcí. 🤭 Vyzkoušeli jsme placenou verzi a opravdu stojí za to – ještě nikdy jsme nedosáhli takové úrovně potěšení.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Pokud chcete okořenit váš vztah, tato aplikace je perfektní! Už jsem zkoušela jiné aplikace, ale žádná nás neuspokojila tak jako tato. Naše předehra byla mnohem žhavější a příjemnější (a teď si představte ten zbytek!). Opravdu stojí za to koupit si placenou verzi (pokud chcete zažít intenzivnější potěšení), ale i bezplatná verze nás překvapila.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Vynikající! Opravdu velmi dobrá... Během hry jsme byli neuvěřitelně vzrušení, což udělalo sex mnohem intenzivnější a plný potěšení! Už se těšíme, až si zahrajeme znovu 💦🔥. Doporučujeme také placenou verzi, pokud zvládnete tolik vzrušení 🤤.",
  tituloBloco6Novo:
    "Dělat jako stovky párů po celém světě a okořeňte svůj vztah.Objevte více než 800 nových výzev!",
  texto6Select: "Vyberte verzi:",
  texto6Premium: "Premium",
  texto6Assinatura: "předplatné",
  texto6Mensal: "Měsíční",
  texto6Anual: "Roční",
  texto6Vitalicia: "Doživotní licence",

  bePremium: "Staňte se prémiovým uživatelem",
  buyNew: "Koupit",
  attention: "Pozor!",
  changeGender: "Změnili jste svou sexuální orientaci",

  tituloAvaliacao: "Máte rádi hru?",
  textoAvaliacao: "Ohodnoťte nás a pomozte nám pokračovat v zlepšování!",
  agoraNão: "Nyní ne",
  enviarAvaliacao: "Odeslat",

  nomeJogo1: "Pikantní výzvy",
  nomeJogo2: "Pravda nebo Úkol?!",
  nomeJogo3: "Úroveň drzosti",
  nomeJogo4: "Zlobivá Ruleta",
  nomeJogo5: "Věta dne",
  naughtyQuiz: "Hříšný kvíz",

  playAlone: "Hrát sám",
  estaSozinho: "Jste sám?",
  selectPlayer: "Vyberte hráče",

  skip: "Přeskočit",
  responder: "Odeslat",
  respondaAqui: "Odpovězte zde",
  config4: "Vyberte avatary k přizpůsobení",

  tituloSelect1: "Hrajete sami?",
  tituloSelect2: "Odpovídejte na kompromitující otázky!",

  subTituloSelect1: "Podáme ti pomocnou ruku!",
  subTituloSelect2: "Zjistěte, jak jste drzá!",
  txtJogador1:
    "Vyberte si svého hráče a objevte řízené sólo potěšení navržené právě pro vás!",
  txtJogador2: "Vybraný hráč bude odpovídat na otázky",
  tituloCena: "KTERÉ POLOŽKY CHCETE POUŽÍT?",
  subTituloCena: `Nemáte něco? Klepněte na "Získejte" a kupte si v partnerském obchodě`,
  play: "Hrát",

  titleUserWarning: "Vyberte uživatele",
  txtUserWarning: "Vyberte uživatele k odpovědi na otázky",

  shareNivelDeSafadeza:
    "Hej, podívej se na moji úroveň nezbednictví 😈 Zažij intenzivní okamžiky rozkoše. Ty taky 💋 Stáhni si aplikaci teď a připrav se na horké výzvy 🔥 se svým partnerem: ➡️ https://pálivévýzvyapp.page.link/sharelevelhot",

  shareDica:
    "Změňte svůj milostný život hned teď! Stáhněte si aplikaci a objevte tajemství pikantního vztahu: ➡️ https://pálivévýzvyapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Jste zdrženlivá osoba, nepříliš vás zajímá nezbedný život, raději máte něco romantického!",
  resultadoQuiz2:
    "Jste až příliš romantická na to, abyste se nechala strhnout nezbednostmi, a více upřednostňujete atmosféru svíček.",
  resultadoQuiz3:
    "Jste docela zdrženlivá osoba a věříte v udržování věcí diskrétních a soukromých v osobním životě.",
  resultadoQuiz4:
    "To neznamená, že nejste občas trochu ztřeštěná, ale raději si toto vzplanutí necháte pro někoho zvláštního.",
  resultadoQuiz5:
    "Vaše vášeň je na pozadí, ale to nezmění skutečnost, že v sobě máte plamen!",
  resultadoQuiz6:
    "Ráda zkoumáte nové zážitky, ale vždy s respektem a souhlasem.",
  resultadoQuiz7:
    'Milujete horká setkání plná polibků a vášně. Přesto máte také stránku, která si užívá sledování filmu, držíc se za ruku se svým "crush" nebo večeři při svíčkách.',
  resultadoQuiz8:
    "Jste připravena na vyzkoušení nových a vzrušujících věcí, ale vždy s odpovědností.",
  resultadoQuiz9:
    'Jste odvážná osoba a ráda dochutnáte svůj intimní život občasným "pikantním kořením".',
  resultadoQuiz10:
    "Máte ráda všechny radosti života a nemáte limity, pokud jde o sex.",
  resultadoQuiz11:
    "S vámi neexistuje špatný čas a kdykoli je dobrý čas na rychlou akci! Romantický film? Jen pokud je to Padesát odstínů šedi!",
  resultadoQuiz12:
    "Pro vás je intimita neustálou dobrodružnou cestou a nemáte strach z rizika.",
  mes: "Měsíc",
  desafiosRestantesDois: "Máte ještě 2 zbývající prémiové výzvy!",
  nenhumDesafioRestante: "Žádné zbývající prémiové výzvy!",
  tornePremiumAviso1:
    "Staňte se nyní prémiovým uživatelem a užijte si 1000 exkluzivních výzev!",
  tornePremiumAviso2:
    "Užijte si neomezené výzvy, exkluzivní obsah a nepřerušenou zábavu!",
  conteudoPremium: "Vybrali jste prémiový obsah!",
  aproveite4desafios:
    "Využijte 4 prémiové výzvy a ochutnejte exkluzivní potěšení.",
  calculando: "Výpočet výsledků...",
  nivelRomantismo: "Tvůj romantický level je...",
  finalizar: "Dokončit",
  erroQuizTitulo: "Zadejte svou odpověď",
  erroQuizFrase: "Pro pokračování zadejte svou odpověď!",
  new: "Nová aplikace",

  //resposta quiz safadeza

  resQuiz1: "Jemný",
  resQuiz2: "Vášnivý",
  resQuiz3: "Očarující",
  resQuiz4: "Super zlobivý",

  texto6Semanal: "Týdenní",
  weekly: "Týdenní Podpis",

  tempSemanal: "Týdenně účtováno",
  tempMensal: "Měsíčně účtováno",
  tempAnual: "Ročně účtováno",
  tempSempre: "Jednorázová platba",
  canceleAny: "Kdykoliv zrušit",

  //Tela do safadrometro
  Low: "Nízký",
  Medium: "Střední",
  High: "Vysoký",
  lifeTime: "Doživotní přístup",
  notNow: "Ne teď, díky.",
  match: "MATCH S UMĚLOU INTELIGENCÍ.",

  dateTitle: "Chcete vyzkoušet naši novou aplikaci?",

  dateBody:
    "Chcete si povídat s nezbednými 😈 boty a procvičovat své flirtování? Bude to zábava! 🔥",
  goToDate: "Vyzkoušejte Date.AI hned teď!",
  goodForU: "BYLO TO PRO VÁS DOBRÉ?",
  rateOurPerformance: "Ohodnoťte náš výkon doposud",
  veryGood: "Velmi dobré",
  veryBad: "Velmi špatné",
  feedbackChallenge: `Co by vás přimělo sdílet aplikaci Hot Challenges s ostatními páry a proč?`,
  type: "Napište svou odpověď sem...",
  survey: "Průzkum spokojenosti.",
  shareIfConfortable: "Neváhejte sdílet s přáteli, pokud jste v pohodě :)",

  howToPlay: "Jak hrát",
  howToPlayHotChallenge:
    "Připravte se okořenit věci! Vytáhněte kartu výzvy a překvapte svého partnera žhavou akcí!",

  preGameTip1:
    "Uvolněte své touhy a vytvořte nezapomenutelné okamžiky se svým partnerem!",
  preGameTip2:
    "Zažehněte své vášně a vytvořte nezapomenutelné okamžiky společně!",
  preGameTip3:
    "Prozkoumejte své nejdivočejší touhy a vytvořte nezapomenutelné vzpomínky!",
  preGameTip4: "Uvolněte své fantazie a užívejte si chvíle čisté rozkoše!",
  selecionajoagador: "Čas hrát",
  dica: "Rada",
  howToPlayNaughty:
    "Vyberte si své oblíbené hračky a předměty. Roztočte kolo a nechte osud rozhodnout o vaší další odvážné výzvě!",
  howToPlayTruthOrDare:
    "Vyber si svůj osud: řekni pravdu nebo přijmi odvážnou výzvu. Ať zábava začne!",
  howToKama1: "Objevte Pozice Rozkoše – 365 Dní Vášně!",
  howToKama2:
    "Vyberte si náhodnou kartu, vyzkoušejte pozici a společně objevujte nové výšiny potěšení!",
  kamaExplain:
    "Odemkněte každý den novou polohu a vytvořte si svou ultimátní sbírku vášně – vaše cesta 365 dnů nezapomenutelného potěšení začíná zde!",
  howToDo: "Jak na to",
  pergunta: "Otázka",
  restart: "Restartovat",
  dialogText1HotChallenges:
    "Dokončili jste všechny dostupné výzvy s vybranými kategoriemi.",
  dialogText2HotChallenges:
    "Vyberte další kategorie nebo restartujte hru s aktuálními výzvami!",
  noChallenges: "Žádné výzvy!",

  objects: "Objekty",
  dialogText1NaughtyGames:
    "Dokončili jste všechny dostupné výzvy se zvolenými objekty.",
  dialogText2NaughtyGames:
    "Vyberte více objektů nebo restartujte hru s aktuálními výzvami!",
  unlockPremium: "Odemknout Premium",
  noCategory: "Vyberte prosím alespoň jednu kategorii pro začátek.",
  thanksForFeedback: "Děkujeme, že nám pomáháte zlepšit zážitek!",
  categoryKamasutra: "Vyberte si svou vášeň a hrajte!",
  tap: "Klepněte pro odhalení vaší polohy!",
  step: "Průvodce Krok za Krokem",
  shareQuizButton: "Sdílej svou úroveň zlobivosti!",
  tryAgain: "Zkuste to znovu",
  unlockAllFun: "Odemkněte veškerou zábavu",
  limitedOffer: "Speciální nabídka na omezenou dobu!",
  fill: "Vyplňte své jméno a jméno svého partnera či partnerky.",

  kamaNotificationTitle: "🔥 Tvoje nová karta je odemčena!",
  kamaNotificationBody:
    "Tvoje pozice pro den {variavel} je připravena. Co takhle dnes vyzkoušet něco nového? 💋",

  titleNewGame: "Připravte se na Roleplay!",
  phraseNewGame:
    "V příští aktualizaci přijde nová hra, která vám umožní prozkoumat vaše nejkreativnější fantazie. Vyberte si postavy, vytvářejte příběhy a zvyšte úroveň zábavy se svým partnerem. 🔥",
  awaitNewGame: "Těšte se a připravte se na jedinečné okamžiky!",

  selectObjects:
    "Vyberte dvě nebo více položek pro přizpůsobení své hry. Prozkoumejte na maximum.",
  soon: "JIŽ BRZY",
  wantToBeNotify: "Chci být informován.",
  ok: "OK",
  vezDe: "OTOČIT",

  categoryLabel: "Kategorie",
  descriptionLabel: "Popis",

  loginConnect: "Přihlásit se",
  loginNoAccount: "Nemáte účet?",
  loginCreateNow: "Vytvořit nyní",
  loginOrConnect: "nebo se připojte",

  email: "Email",
  password: "Heslo",
  loginRegister: "Registrovat",
  loginAlreadyHas: "Již máte účet?",
  enterNow: "Vstoupit nyní",

  logout: "Odhlásit se",
  customerPortal: "Zákaznický portál",
  installApp: "Nainstalovat aplikaci",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/tcheco.mp4",
};
